import React from "react";
import "./Badge.css";

const COLOR_MAP: Record<string, string> = {
  // Placement pipeline
  "Internal Submittal":    "#fbe8e6",
  "Resume Sent To Client": "#fef3c7",
  "First Interview":       "#dcfce7",
  "Second Interview":      "#dcfce7",
  "Offer Extended":        "#dbeafe",
  "Placed / Hired":        "#dcfce7",
  "Rejected / Closed":     "#fee2e2",
  // Scrape / tracking status
  ACTIVE:                  "#dcfce7",
  PAUSED:                  "#fef3c7",
  STOPPED:                 "#fee2e2",
  active:                  "#dcfce7",
  paused:                  "#fef3c7",
  stopped:                 "#fee2e2",
  cannot_be_tracked:       "#f3f4f6",
  // Referral outcomes
  WIN:                     "#dcfce7",
  LOSS:                    "#fee2e2",
  placed:                  "#dcfce7",
  not_placed:              "#fee2e2",
  Open:                    "#fef3c7",
  manual_review:           "#fef3c7",
  expired:                 "#fee2e2",
  // Ohio move/employer states
  completed:               "#dcfce7",
  not_detected:            "#fee2e2",
  detected:                "#dcfce7",
  already_in_ohio:         "#dbeafe",
  // Sync status
  RUNNING:                 "#dbeafe",
  SUCCESS:                 "#dcfce7",
  FAILED:                  "#fee2e2",
  NEVER_RUN:               "#f3f4f6",
  // Resource / user status
  Active:                  "#dcfce7",
  "Do Not Use":            "#fee2e2",
};

const DISPLAY_MAP: Record<string, string> = {
  not_detected: "Tracking Expired",
  not_placed:   "Tracking Expired",
  paused:       "Untrackable",
};

interface BadgeProps { text: string; }

export default function Badge({ text }: BadgeProps) {
  const display = DISPLAY_MAP[text] ?? text.split("_").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  return (
    <span
      className="badge"
      style={{ backgroundColor: COLOR_MAP[text] || "#f3f4f6" }}
    >
      {display}
    </span>
  );
}
